import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function TopBanner() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 52
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          return {
            hours: 0,
            minutes: 15,
            seconds: 0
          }; // Reset or stop
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="text-white py-2 px-4 fixed top-0 left-0 z-[70] pointer-events-none" data-id="element-341">
      <div className="flex items-center gap-2 text-sm md:text-base font-black uppercase tracking-tighter italic bg-[#0a0514]/40 backdrop-blur-sm p-2 rounded-br-xl border-b border-r border-white/10" data-id="element-342">
        <Timer className="w-4 h-4 md:w-5 h-5 animate-pulse text-red-500" data-id="element-343" />
        <div className="flex gap-1 font-mono text-lg md:text-xl px-1 rounded" data-id="element-344">
          <span data-id="element-345">{formatNumber(timeLeft.hours)}</span>
          <span className="animate-pulse text-red-500" data-id="element-346">:</span>
          <span data-id="element-347">{formatNumber(timeLeft.minutes)}</span>
          <span className="animate-pulse text-red-500" data-id="element-348">:</span>
          <span data-id="element-349">{formatNumber(timeLeft.seconds)}</span>
        </div>
      </div>
    </div>;
}